export function getStatusColor(state: string, forcedAllocation: boolean | null | undefined) {
  switch (state) {
    case 'requested':
      return 'chip bg-warning-strong text-badge-filled-warning'
    case 'accepted':
      return forcedAllocation ? 'chip bg-button-primary-success' : 'chip bg-success-strong text-badge-filled-success'
    case 'denied':
      return forcedAllocation ? 'chip-grey' : 'chip bg-surface-inverse'
    default:
      return 'chip-grey'
  }
}

export function getStatusLabel(state: string, forcedAllocation: boolean | null | undefined) {
  if (state == 'accepted' && forcedAllocation) return 'attendee.acceptedSuccessor'
  if (state == 'denied' && forcedAllocation) return 'attendee.requested'
  return `attendee.${state}`
}
